import * as React from 'react';
import {
    ArrayField,
    Datagrid,
    FunctionField,
    Loading,
    RecordContextProvider,
    ReferenceField,
    FormDataConsumer,
    TextField,
    Link
} from 'react-admin';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { Box, Typography } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';


const GET_COURSE_MODULES = gql`
    query CourseModule($id: ID!) {
        data: CourseModule(id: $id) {
            id
            courseTitle
            modules {
                id
                moduleCode
                moduleTitle
                moduleCreditLevelId
                moduleCreditValueId
                moduleType
                moduleStatusId
            }
        }
    }
`;

export const CourseModulesShow = () => {
    let params = useParams();

    const { loading, error, data } = useQuery(GET_COURSE_MODULES, {
        variables: { id: params.courseId },
    });

    if (error) {
        return <p>Error loading course modules</p>;
    }
    if (loading) {
        return <Loading />;
    }

    const courseModule = data?.data;
    const courseTitle = courseModule?.courseTitle;

    if (courseModule?.modules && courseModule.modules.length > 0) {
        return (
            <>
                <Typography variant="h5" sx={{ mt: 2 }}>
                    Course Structure for {courseTitle}
                </Typography>
                <CourseModuleList courseModules={courseModule.modules} />
            </>
        );
    }

    return (
        <Typography variant="h5" sx={{ mt: 2 }}>
            No Modules for Course : {courseTitle}
        </Typography>
    );
};

const CourseModuleList = ({ courseModules }) => {
    const modulesGroupByLevel = _(courseModules)
        .groupBy((m) => m.moduleCreditLevelId)
        .map((value, key) => ({ creditLevel: key, modules: value }))
        .value();

    return (
        <>
            {modulesGroupByLevel.map((moduleGroup) => {
                return (
                    <>
                        <CourseModuleLevel
                            key={moduleGroup.creditLevel}
                            moduleGroup={moduleGroup}
                        />
                    </>
                );
            })}
        </>
    );
};

const CourseModuleLevel = ({ moduleGroup }) => {
const theme = useTheme();
var lightStyle = {
    '& .RaDatagrid-rowEven': {
        backgroundColor: '#FAFAFA',
    },
    '& .RaDatagrid-headerCell': {
        fontWeight: 'bold',
    },
    border: 1,
    mt: 2,
}

var darkStyle = {
    '& .RaDatagrid-rowEven': {
        backgroundColor: '#1c1c1c',
    },
    '& .RaDatagrid-headerCell': {
        fontWeight: 'bold',
    },
    border: 1,
    mt: 2,
}
    return (
        <RecordContextProvider value={moduleGroup}>
            <Box sx={{ mt: 4 }}>
                <ReferenceField
                    reference="CreditLevel"
                    source="creditLevel"
                    link={false}
                >
                    <FunctionField
                        render={(record) => `Level ${record.Title} Modules`}
                        sx={{ fontSize: 20 }}
                    />
                </ReferenceField>
                <ArrayField source="modules">
                    <Datagrid
                        bulkActionButtons={false}
                        sx={theme.palette.mode === 'dark' ? darkStyle : lightStyle}>

                        {/* <ReferenceField
                            reference="Module"
                            source="id">
                            <TextField source="moduleCode" />
                        </ReferenceField> */}
                        <TextField source="moduleCode" />
                        <TextField source="moduleTitle" />
                        <ReferenceField
                            reference="CreditValue"
                            source="moduleCreditValueId"
                            link={false}
                        >
                            <TextField source="creditvalue" />
                        </ReferenceField>
                        <ReferenceField
                            reference="Status"
                            source="moduleStatusId"
                            link={false}
                        >
                            <TextField source="Title" />
                        </ReferenceField>
                        <TextField source="moduleType" />
                    </Datagrid>
                </ArrayField>
            </Box>
        </RecordContextProvider>
    );
};
